import { api } from 'api';
import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import { REGISTER_PREFIX } from 'constants';
import useCommonStore from 'hooks/useCommonStore';
import usePortalModal from 'hooks/usePortalModal';
import useQuery from 'hooks/useQuery';
import React, { useEffect, useState } from 'react';
import { domUtils } from 'utils';

const withCheckReferralLinkExpired = (Component) => {
  const CheckReferralLinkExpiredComponent = (props) => {
    const { showPortalModalName } = usePortalModal();
    const query = useQuery();
    const referralCode = query.get('referralCode');
    const { setLoading } = useCommonStore();

    const [isReferralLinkChecking, setReferralLinkChecking] = useState(true);

    const onCheckReferralLinkExpired = async () => {
      setLoading(true);
      try {
        const { data } = await api.checkValidReferralCode(referralCode);
        if (data) {
          const { isValid } = data || {};
          if (!isValid) {
            showPortalModalName({
              name: PORTAL_NAME_MODAL_DEFINE.REFERRAL_LINK_EXPIRED_MODAL,
              action: () => {
                domUtils.replaceUrlWithReload({ path: REGISTER_PREFIX });
              },
            });
          } else {
            setReferralLinkChecking(false);
          }
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setReferralLinkChecking(false);
        console.error(error?.message);
      }
    };

    useEffect(() => {
      if (!referralCode) {
        setReferralLinkChecking(false);
        return;
      }
      onCheckReferralLinkExpired();
    }, []);

    const newProps = {
      ...props,
      isReferralLinkChecking,
    };
    return <Component {...newProps} />;
  };
  return CheckReferralLinkExpiredComponent;
};

export default withCheckReferralLinkExpired;
